<template>
    <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'">
        <CloseTradesTable></CloseTradesTable>
    </v-card>
</template>
<script>
import CloseTradesTable from "./CloseTradesTable.vue";
export default {
    components: { CloseTradesTable },
};
</script>
